var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tr-list mp-promos"},[_c('div',{staticClass:"tr-listWrap"},[_vm._l((_vm.promotions),function(promotion,id){return _c('promotion-preview',{key:`new-${id}`,staticClass:"o-promoPreview--list",attrs:{"preview-type":_vm.previewType,"group-id":_vm.groupId,"acceptance":_vm.acceptance,"promotion":promotion}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }